import Vue from 'vue'
import BaseService from '../../../services/BaseService'
import { SET_LOADING, SET_BASE_STATE_VALUE, ADD_ALERT_MESSAGE, REMOVE_ALERT_MESSAGE } from './variables'
import { ALERT_TIMEOUT } from '../../../constants'

const state = {
  messagesAlertList: {},
  loading: false,
  countries: [],
  banks: []
}

const mutations = {
  [SET_LOADING]: (state, value) => {
    state.loading = value
  },
  [SET_BASE_STATE_VALUE]: (state, value) => {
    state[value[0]] = value[1]
  },
  [ADD_ALERT_MESSAGE]: (state, payload) => {
    Vue.set(state.messagesAlertList, payload.key, payload.value)
  },
  [REMOVE_ALERT_MESSAGE]: (state, key) => {
    if (state.messagesAlertList[key]) {
      Vue.delete(state.messagesAlertList, key)
    }
  }
}

const getters = {}

const actions = {
  countriesRequest({ commit }) {
    commit(SET_LOADING, true)
    BaseService.getCountries()
      .then(response => commit(SET_BASE_STATE_VALUE, ['countries', response.data.response.countries]))
      .catch(error => commit(SET_BASE_STATE_VALUE, ['errorMessage', error]))
      .finally(() => commit(SET_LOADING, false))
  },
  banksRequest({ commit, dispatch, rootGetters }) {
    commit(SET_LOADING, true)
    commit(SET_BASE_STATE_VALUE, ['banks', []])
    BaseService.getBanks(rootGetters['personal/selectedCountry'])
      .then(response => commit(
        SET_BASE_STATE_VALUE,
        ['banks', response.data.response.banks.sort((a, b) => {
          const nameA = a.name.toUpperCase()
          const nameB = b.name.toUpperCase()
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }
          return 0
        })]))
      .catch(error => dispatch('pushAlertMessage', { message: error }))
      .finally(() => commit(SET_LOADING, false))
  },
  pushAlertMessage({ commit }, payload) {
    const randomIndex = Math.random().toString(36).substring(7)
    const message = payload.message ? payload.message : 'Error happened'
    const type = payload.type || 'error'

    commit(ADD_ALERT_MESSAGE, { key: randomIndex, value: { message, type } })
    setTimeout(() => {
      commit(REMOVE_ALERT_MESSAGE, randomIndex)
    }, ALERT_TIMEOUT)
  }
}

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
